import React from 'react';
import css from './cappa-components.module.css';
import { LeafIconLogo } from '../../../components/LeafIconLogo/LeafIconLogo';
import { NamedLink, PrimaryButton, SecondaryButton } from '../../../components';
import { FormattedMessage } from 'react-intl';

const LandingBottomCtaSection = ({ isUserOnLanding }) => {
  return (
    <div className={css.bottomCtaSection}>
      <div className={css.bottomCtaSectionLogo}>
        <LeafIconLogo className={css.leafIconLogo} />
      </div>
      <div className={css.bottomCtaSectionContent}>
        <div className={css.bottomCtaSectionTitle}>
          <FormattedMessage
            id="LandingPage.cappaComponents.bottomCtaSectionTitle"
            defaultMessage="Find the right care team for you!"
          />
        </div>
        {isUserOnLanding ? null : (
          <div className={css.bottomCtaSectionButtons}>
            <NamedLink
              href="/signup/parent"
              name="SignupForParent"
              activeClassName={css.activeLink}
            >
              <PrimaryButton
                style={{ padding: 0, minHeight: 40, minWidth: 200 }}
                onClick={() => {}}
              >
                <FormattedMessage id="Cappa.HomepageLeftButton" defaultMessage={"I'm a parent"} />
              </PrimaryButton>
            </NamedLink>

            <NamedLink
              href="/signup/careProvider"
              name="SignupForCareProvider"
              activeClassName={css.activeLink}
            >
              <SecondaryButton
                style={{ padding: 0, minHeight: 40, minWidth: 200 }}
                onClick={() => {}}
              >
                <FormattedMessage
                  id="Cappa.HomepageRightButton"
                  defaultMessage={"I'm a Care provider"}
                />
              </SecondaryButton>
            </NamedLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default LandingBottomCtaSection;
